import { useContext } from 'react'

import { OtbPlanContext } from '@provider/Otb/PlanProvider'

import { IOtbPlanContext } from '@base/@types/providers/Otb/PlanProvider'

export default function useOtbPlan(): IOtbPlanContext {
  const context = useContext(OtbPlanContext)

  return context
}
